<section class="page-home">  
  <modulos-destaque></modulos-destaque> 
  <modulo posicao="whatsapp" template="fixo"></modulo> 
</section>   

 



